export default __webpack_public_path__ + "static/media/sales.3b112da1.svg";